import React, { useEffect, useMemo } from 'react';

import useTheme from '../../../../hooks/use-theme/useTheme';

import { getClassNames } from '../../../../utils/util';

import '../validation.scss';

type Props = {
  username: string;
  setValidUsername: (bool: boolean) => void;
};

const UsernameValidation = ({ username, setValidUsername }: Props) => {
  const { pps } = useTheme();

  const hasNoSpace = useMemo(() => !username.includes(' '), [username]);
  const hasThreeCharacters = useMemo(() => username.length > 2, [username]);
  const hasNoSpecialCharacters = useMemo(() => /^[a-zA-Z0-9._-]*$/.test(username), [username]);

  useEffect(() => {
    setValidUsername(hasNoSpace && hasThreeCharacters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasNoSpace, hasThreeCharacters]);

  return (
    <div className={getClassNames('validation', { pps })}>
      <div className="validation__rule">
        <span className={getClassNames('validation__rule__bullet', { satisfied: hasThreeCharacters, pps })} />
        <p className={getClassNames('validation__rule__text', { pps })}>At least 3 characters</p>
      </div>
      <span />
      <div className="validation__rule">
        <span className={getClassNames('validation__rule__bullet', { satisfied: hasNoSpace, pps })} />
        <p className={getClassNames('validation__rule__text', { pps })}>No spaces allowed</p>
      </div>
      <span />
      <div className="validation__rule">
        <span className={getClassNames('validation__rule__bullet', { satisfied: hasNoSpecialCharacters, pps })} />
        <p className={getClassNames('validation__rule__text', { pps })}>No special characters allowed</p>
      </div>
    </div>
  );
};

export default UsernameValidation;
